import React from 'react';
import { BaseLayoutFactory } from '../global/base-layout-factory';
import { AgreementDetailProvider } from './context/agreement-detail-context';
import { AgreementDetailComponent } from './agreement-detail-component';

export function AgreementDetailFactory() {
  return (
    <BaseLayoutFactory>
      <AgreementDetailProvider>
        <AgreementDetailComponent />
      </AgreementDetailProvider>
    </BaseLayoutFactory>
  );
}
